import React from 'react';
import '../CSS/App.css';
import ProjectCard from '../Components/ProjectCard';
import cabreraDrive from '../Media/cabreraDrive.png'
import capyjump from '../Media/capyjump.png'
import portfolio from '../Media/portfolio.png'
import server from '../Media/server.png'
import rezepe from '../Media/rezepe_preview.png';
import library from '../Media/library.png'
import ai from '../Media/ai.png'

const Projects = () => {
  const projectData = [
    {
      image: rezepe,
      title: 'Rezepe',
      description: 'Full-stack recipe platform built with React, Node.js, Express, MySQL, and JWT auth — containerized with Docker and self-hosted on a home Ubuntu server with Nginx reverse proxy.',
      githubLink: 'https://github.com/jermy79/recipe-app/',
      liveDemoLink: 'https://rezepe.com',
      blogLink: '/blog/rezepe',
    },
    {
      image: library,
      title: 'Library Management System',
      description: 'Built the Java backend with MySQL, JDBC, and REST APIs for a group project, enabling teammates to query, add, and update book records through a secure and scalable service layer.',
      githubLink: 'https://github.com/jermy79/LibraryManagementSystem',
      blogLink: '/blog/library',
    },
    {
      image: ai,
      title: 'Digital AI Clone',
      description: 'Fine-tuned LLaMA on personal Instagram DM history using Python, Unsloth, Hugging Face, and LoRA — built a full data pipeline, training workflow with auto-checkpointing, and a chat interface that mimics real texting flow. Senior capstone project.',
      githubLink: '',
      blogLink: '/blog/ai-clone',
    },
    {
      image: cabreraDrive,
      title: 'Home NAS Solution',
      description: 'Self-managed home server running Ubuntu Server, Docker, Nginx Proxy Manager, and Pi-hole/AdGuard — handling DNS, reverse proxy, file storage, and self-hosted applications.',
      githubLink: '',
      blogLink: '/blog/home-nas',
    },
    {
      image: server,
      title: 'Ubuntu Home Lab',
      description: 'Transformed an old ThinkPad into a production home server using Ubuntu Server, Docker, and Nginx Proxy Manager — hosting websites, storage, and self-hosted services with public internet access.',
      githubLink: '',
      liveDemoLink: '',
      blogLink: '/blog/ubuntu-lab',
    },
    {
      image: capyjump,
      title: 'Capy Jump',
      description: 'Flappy Bird clone built in Godot Game Engine using GDScript. Published on itch.io.',
      githubLink: 'https://github.com/jermy79/Capy-Jump',
      liveDemoLink: 'https://jerm079.itch.io/capy',
      blogLink: '/blog/capy-jump',
    },
    {
      image: portfolio,
      title: 'Portfolio Website',
      description: 'Built and deployed using React, Node.js, and Nginx reverse proxy — self-hosted on a home Ubuntu server for public access.',
      githubLink: '',
      liveDemoLink: 'https://jeremy-cabrera.com',
      blogLink: '/blog/portfolio',
    },
  ];

  return (
    <div>
      <p className='title'>Projects</p>
      <div className='projects-container'>
        <div className='projects-grid'>
          {projectData.map((project, index) => (
            <ProjectCard
              key={index}
              image={project.image}
              title={project.title}
              description={project.description}
              githubLink={project.githubLink || null}
              liveDemoLink={project.liveDemoLink || null}
              blogLink={project.blogLink || null}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
